/** @file Writes a new list over a draft list element by element when its length stays (O(change) patches). */

/**
 * Stores `next` in place of `list`. With the same length, only the elements `same` reports as different are written,
 * one patch each (R17-01b), unless more than a quarter differ, then one replace is smaller; a new length always
 * replaces the list through `replace`. Returns false when every element is the same (nothing written).
 */
export function writeChanged<T>(list: T[], next: readonly T[], same: (a: T, b: T) => boolean, replace: (next: T[]) => void): boolean {
  if (list.length !== next.length) {
    replace([...next]);
    return true;
  }
  const changed = next.flatMap((value, i) => (same(list[i] as T, value) ? [] : [i]));
  if (changed.length === 0) return false;
  if (changed.length * 4 > next.length) replace([...next]);
  else for (const i of changed) list[i] = next[i] as T;
  return true;
}
